import styles from 'styles/TextBannerScreen.module.css'
import _ from 'lodash'

type TextBannerScreenPropsType = {
  bannerText?: string;
  selectedAvatar?: string;
}

function TextBannerScreen({ bannerText, selectedAvatar,  }: TextBannerScreenPropsType) {

  
const text : { [key: string]: any } = {
  'pirate': 'Style it like a Pirate',
  'space explorer': 'Outfit for Outer Space',
  'wizard': 'Wear it like a Wizard',
};


  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {bannerText} <span className={styles.headingText}>{selectedAvatar && text[selectedAvatar]}</span>
      </div>
    </div>
  )
}

export default TextBannerScreen
